export default __webpack_public_path__ + "static/media/trade.882a2473.svg";